export const APP_VERSION = import.meta.env.PACKAGE_VERSION;
export const TELEGRAM_LINK = "https://t.me/rubansky1";
export const GITHUB_LINK = "https://github.com/Syozik/fcknetflix";
export const GA_ID = import.meta.env.VITE_GA_ID;
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
